<template>
  <!-- eslint-disable vue/no-mutating-props -- account is a nested reactive object from parent form state, bound via v-model -->
  <fieldset>
    <div class="group">
      <template v-for="category in incomeCategories" :key="category.value">
        <div class="field" v-if="!category.studentOnly || isStudent">
          <label :for="fieldId('account', index, 'income', category.value)">{{ category.label }}</label>
          <div>
            <div data-prefix="€">
              <input
                :id="fieldId('account', index, 'income', category.value)"
                type="text"
                inputmode="numeric"
                v-model="account.financial.income[category.value]"
                v-on:focus="(v) => (v.target as HTMLInputElement).setSelectionRange(0, 9999)"
                placeholder="0"
              />
            </div>
            <v-form-error :error="errors[`accounts.${index}.financial.income.${category.value}`]" />
          </div>
        </div>
      </template>
    </div>
  </fieldset>
</template>

<script lang="ts" setup>
import { useRegistrationContext } from '/@front:shared/composables/useRegistrationContext'
import type { Account } from '/@front:shared/registration'
import { fieldId } from '/@front:shared/utils'

defineProps<{
  account: Account
  index: number
  errors: Record<string, string>
  isStudent: boolean
}>()

const { incomeCategories } = useRegistrationContext()
</script>
